import React, { useState, useEffect, useContext,useCallback, Fragment } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from "react-bootstrap";

const FinanceBusinessList = ({
  getprojectOnboardingListForFinance,
  projectOnboradingListing = [],
  fetchZones,
  filterDropdownList = null,
  getFetchZones = null,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);

  const Headers = [
    'Project Id',
    'Recon Business Id',
    'Project Type',
    'Client Name',
    'Address',
    'City',
    'State',
    'Pincode',
    'Latitude',
    'Longitude',
    'Status',
    'Action',
  ];
  console.log('PAGE::FINANCE-BUSINESS-LIST');
  useEffect( () => {
    (async () => {
      setIsLoading(true)
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
      await getprojectOnboardingListForFinance(null, 1)
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    const tableData = [
        'id',
      'infra_project_id',
      'recon_business_id',
      'lead_type',
      'client_name',
      'address_line_1',
      'city',
      'geo_state',
      'geo_pincode',
      'latitude',
      'longitude',
       'project_status'
    ];
    const actions = [
      { name: 'View Details', link: `${baseUrl}/view-details` },
      // { name: 'Edit Details', link: `${baseUrl}/edit-project` },
      // { name: 'View POC', link: `${baseUrl}/viewPoc` },
      {name : 'Add Address', link: `${baseUrl}/add-location/2`} //2 append for business address
    ];
    setListData()
    if (
        projectOnboradingListing && projectOnboradingListing.resultSets?.data &&
        projectOnboradingListing.resultSets?.data.length > 0
    ) {
      const data = projectOnboradingListing.resultSets?.data.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  key === 'city' && element['city'] !== null ? {['city'] : element['city']['city_name']}
                      : key === 'lead_type' && element['lead_type'] !== null ? {['project_type']: element['lead_type']['name']}
                          : key === 'geo_state' && element['geo_state'] !== null ? { ['state'] : element['geo_state']['state_name'] }
                          : key === 'address_line_1' ? {['address'] : element['address_line_1']+" "+element['address_line_2']}
                                  : key === 'geo_pincode' && element['geo_pincode'] !== null  ? {['pincode'] : element['geo_pincode']['pincode']}
                          : key === 'project_status' ? { project_status: element.project_status_name ?? element.project_status }
                  : {
                [key]: element[key],

              })

              ),{Action: actions}
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(projectOnboradingListing?.total / projectOnboradingListing?.per_page));
    }
  }, [projectOnboradingListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getprojectOnboardingListForFinance(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={{
            pathname: `${baseUrl}/finance-add-business`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.addBusiness}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
        <Button
            onClick={filterToggle}
            className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
        
    </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getprojectOnboardingListForFinance(filter, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.businessList}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      //isGoback
      isLoading={isLoading}
      //linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp`}
    >
      <TableSection
          data={listData}
          headers={Headers}
          pageCount={pageCount}
          srNo={projectOnboradingListing?.from}
          onPageChange={onPageChange}
          isId={false}
          detailList={projectOnboradingListing && projectOnboradingListing.resultSets?.data}
      />

      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          getZones={(val) => getZones(val)}
          statusId={'1,2,3'}
          listFilterData={filterDropdownList && filterDropdownList.data}
          zones={getFetchZones && getFetchZones.data}
          isRoleId={isRoleId}
          filterPreSalesListing
          projectOnboardingStatus={true}
      />
    </Layout>
  );
};

FinanceBusinessList.propTypes = {};

export default FinanceBusinessList;
